export { default } from './horizontal-rule';
